import { render } from "./EmsRow.vue?vue&type=template&id=22b08107&scoped=true"
import script from "./EmsRow.vue?vue&type=script&lang=js"
export * from "./EmsRow.vue?vue&type=script&lang=js"

import "./EmsRow.vue?vue&type=style&index=0&id=22b08107&scoped=true&lang=css"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b08107"]])

export default __exports__